































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { StripeInvoice } from '../../../api/v2/models/subscription'
import { StripeUpcomingInvoice } from '../../../api/v2/models/subscription'

@Component({})
export default class StripeInvoiceComponent extends Vue {
  @Prop({ required: true })
  stripeInvoice: StripeInvoice

  @Prop({ required: false, default: false })
  showMembershipFee: boolean

  @Prop({ required: false })
  membershipFee: number

  @Prop({ required: false })
  membershipFeePaidAt: string

  @Prop({ required: false })
  membershipFeeChargeAt: string

  @Prop({ required: false })
  membershipFeeChargeFailed: boolean

  @Prop({ required: false })
  membershipFeeChargeFailedMessage: string

  @Prop({ required: false, default: false })
  isLastInvoice: boolean

  @Prop({ required: false, default: false })
  needMembershipFee: boolean

  @Prop({ required: false })
  stripeUpcomingInvoice: StripeUpcomingInvoice

  @Prop({ required: false })
  membershipStatus: string

  retryDialog: boolean = false

  formatDate(input: string | number | Date): string {
    let timestamp: number
    if (input instanceof Date) {
      timestamp = input.getTime()
    } else if (typeof input === 'string') {
      timestamp = new Date(input).getTime()
    } else {
      timestamp = input * 1000
    }
    const date = new Date(timestamp)
    return date.toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '/')
  }

  get membershipFeeDate() {
    if (this.membershipFeeChargeAt) {
      return this.formatDate(this.membershipFeeChargeAt)
    }
    if (this.membershipFeePaidAt) {
      return this.formatDate(this.membershipFeePaidAt)
    }
    if (this.stripeUpcomingInvoice) {
      return this.formatDate(this.stripeUpcomingInvoice.nextPaymentAttempt)
    }

    return this.formatDate(this.stripeInvoice.created)
  }

  get getMembershipFeeStatusColor() {
    if (this.membershipStatus === 'paid') return 'success'
    if (this.membershipFeePaidAt) return 'success'
    if (this.membershipFeeChargeFailed) return 'error'
    return 'primary'
  }

  get getMembershipFeeStatusText() {
    if (this.membershipStatus === 'paid') return '支払い済み'
    if (this.membershipFeePaidAt) return '支払い済み'
    if (this.membershipFeeChargeFailed) return '支払い失敗'
    return '支払い待ち'
  }

  get getMembershipFeeTooltip() {
    if (this.membershipStatus === 'paid') return '入会金の支払いが完了しました。'
    if (this.membershipFeePaidAt) return '入会金の支払いが完了しました。'
    if (this.membershipFeeChargeFailed) return this.membershipFeeChargeFailedMessage
    return '入会金の支払いが必要です。'
  }

  getAmount(invoice: any) {
    let amount = invoice.amountPaid || invoice.amountDue
    let membershipFee = 0
    if (invoice.lines.data.length > 1) {
      membershipFee = invoice.lines.data.find(line => line.description?.includes('Membership Fee'))?.amount || 0
    }

    if (membershipFee > 0) {
      return amount - membershipFee
    }

    return amount
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'draft':
        return 'info'
      case 'open':
        return 'warning'
      case 'paid':
        return 'success'
      case 'void':
        return 'grey'
      case 'uncollectible':
        return 'error'
      default:
        return 'grey'
    }
  }

  getStatusText(status: string): string {
    switch (status) {
      case 'draft':
        return '下書き'
      case 'open':
        return '未支払い'
      case 'paid':
        return '支払い済み'
      case 'void':
        return 'キャンセル'
      case 'uncollectible':
        return '回収不能'
      default:
        return status
    }
  }

  getStatusTooltip(status: string): string {
    switch (status) {
      case 'draft':
        return '請求書はまだ使用する準備ができていません。すべての請求書は下書き状態で開始されます。'
      case 'open':
        return '請求書は確定済みで支払い待ちです。'
      case 'paid':
        return 'この請求書は支払い済みです。これ以上のアクションは必要ありません。'
      case 'void':
        return 'この請求書はキャンセルされました。これ以上のアクションは必要ありません。'
      case 'uncollectible':
        return '顧客が請求書を支払う可能性が低いです。通常、会計処理で不良債権として扱います。'
      default:
        return ''
    }
  }

  openNewTab(url: string): void {
    window.open(url, '_blank')
  }

  get isMembershipFeeInvoice() {
    return this.isLastInvoice && this.needMembershipFee
  }

  get shouldShowMembershipFee() {
    if (!this.showMembershipFee || !this.isMembershipFeeInvoice) {
      return false
    }

    const isCanceledWithPending = this.stripeInvoice.status === 'canceled' && this.getMembershipFeeStatusText === '支払い待ち'
    const noUpcomingAndNotPaid = this.stripeUpcomingInvoice === null && this.membershipStatus !== 'paid'

    return !(isCanceledWithPending || noUpcomingAndNotPaid)
  }

  get shouldShowMembershipFeeWithDivider() {
    return this.shouldShowMembershipFee && this.getMembershipFeeStatusText === '支払い待ち'
  }
}
